export enum DataFlowModuleShapeTypes {
  Rectangle = 'Rectangle',
  Circle = 'Circle',
  Ellipse = 'Ellipse',
  Custom = 'Custom'
}
